module.exports = __webpack_public_path__ + "static/media/tot_cpt.37d3e069.svg";